import { useCallback, useContext, useMemo, useState } from "react";
import { PanelContext, PanelContextType, Props } from "./PanelContext.Parts";

export const PanelProvider = ({ children, defaultOpen = false }: Props) => {
  const [open, setOpenState] = useState(defaultOpen);
  const setOpen = useCallback((next: boolean) => {
    setOpenState(next);
  }, []);
  const toggle = useCallback(() => {
    setOpenState((prev) => !prev);
  }, []);
  const value = useMemo(
    () => ({ open, setOpen, toggle }),
    [open, setOpen, toggle],
  );
  return (
    <PanelContext.Provider value={value}>{children}</PanelContext.Provider>
  );
};

export const usePanelContext = (): PanelContextType => {
  const ctx = useContext(PanelContext);
  if (ctx === undefined) {
    throw new Error("usePanelContext must be used within a PanelProvider");
  }
  return ctx;
};
